import { parse } from 'query-string'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import 'rxjs/add/operator/filter'
import 'rxjs/add/operator/map'
import * as App from '../../app'
import * as DateUtils from '../../components/date-selector/utils'
import * as Menu from '../../components/menu'
import * as Request from '../../request'
import { ApplicationState } from '../../rootReducer'
import * as Router from '../../router'
import * as Actions from './actions'
import * as Constants from './constants'

const isPage = (action: any, history: any) => {
  return (history.location.pathname || '').startsWith(Menu.ADMIN_DROPS_URL) ||
         (action.payload || '').startsWith(Menu.ADMIN_DROPS_URL)
}

export const initialize = (
  action$: ReduxObservable.ActionsObservable<Redux.Action>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(
    App.CONTENT_INIT,
    Router.PUSH,
    Request.successConstant(Constants.CLEAR_DROP),
  )
  .filter((action) => isPage(action, history))
  .map(() => parse(history.location.search))
  .map((query: any) => ({
    date: DateUtils.dateFromUrlParams(history.location),
    limit: (query.limit || 100),
  }))
  .mergeMap(({limit, date}: any) => [
    Actions.fetch(store.getState().app.selectedCommunity, date, limit),
    Actions.updateSelectedDate(date),
  ])

const updateGridOnDateChange: any = (
  action$: ReduxObservable.ActionsObservable<any>,
  store: Redux.Store<ApplicationState>,
  {history}: App.Dependencies,
) => action$.ofType(Constants.UPDATE_SELECTED_DATE)
  .map((action: any) => {
    return Actions.fetch(
      store.getState().app.selectedCommunity,
      action.date,
      ( parse(history.location.search).limit || 100))
    })

export const epic = ReduxObservable.combineEpics(
  initialize,
  updateGridOnDateChange,
)



// WEBPACK FOOTER //
// ./src/pages/drops/epic.ts